import React, {useLayoutEffect} from 'react';
import {AvailabilityInfo, ConfigApi, MenuProductViewType, OrderType} from "../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import ItemAvailabilityHelper from "../../../../services/Menu/services/Item/ItemAvailabilityHelper";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";
import ItemHelper from "../../../../services/Menu/services/Item/ItemHelper";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface Props {
    forceNotAvailable?: true;
    isAvailable: boolean;
    item: Record<string, any>;
    locale: string | undefined;
    availability: any;
    viewType: MenuProductViewType;
    orderType: OrderType;
    pickupDate: string | undefined;
    config: ConfigApi | undefined;
    menus: any[];
    category: any;
    availabilities: any[];
    itemGroup: Record<string, any> | undefined;
    session: Record<string, any>;
    setHasNoAvailableInfo: React.Dispatch<React.SetStateAction<boolean>>
}

const MenuCategoryProductAvailabilityInfo = ({
                                                 forceNotAvailable,
                                                 isAvailable,
                                                 item,
                                                 locale,
                                                 availability,
                                                 viewType,
                                                 orderType,
                                                 pickupDate,
                                                 config,
                                                 menus,
                                                 category,
                                                 availabilities,
                                                 itemGroup,
                                                 session,
                                                 setHasNoAvailableInfo
                                             }: Props) => {
    const {t} = useTranslation();
    const isReadonly = StoreUtils.isOrderingReadonly(config);
    let productAvailabilityInfos: AvailabilityInfo[] = []
    const itemFromCategoryItems = ItemHelper.getItemFromCategoryItems(item, itemGroup, category.entities ?? []);

    useLayoutEffect(() => {
        setHasNoAvailableInfo(!itemFromCategoryItems || (productAvailabilityInfos.length === 1 && productAvailabilityInfos[0].isEverAvailable === false))
    }, [isAvailable, productAvailabilityInfos]);

    if (forceNotAvailable || !category) return <></>;

    if (isAvailable) return <></>;

    const drawAvailabilityInfo = (infoArray: string[]) => {
        if (viewType === MenuProductViewType.HORIZONTAL) return (
            <span className="badge badge-warning text-warning fw-normal" style={{
                whiteSpace: 'pre-wrap',
            }}>
                <span className="badge-warning-text">
                    {infoArray.join(".\n")}
                </span>
            </span>
        )

        return (
            <p className="card-text text-warning fw-normal product-availability-info">
                {infoArray.join(". ")}
            </p>
        )
    }

    if (!itemFromCategoryItems) return drawAvailabilityInfo([t("common.word.not_available")]);

    const itemAvailabilityInfos = ItemAvailabilityHelper.getItemAvailabilityInfo(itemFromCategoryItems, availability, config, menus, availabilities, category, pickupDate, isReadonly ? undefined : orderType, locale, t, !!isReadonly);
    const menusWithCategory = CategoryHelper.getMenusForCategoryByIds(category, menus);
    const menusWithCategoryForItem = itemFromCategoryItems ? menusWithCategory.filter((menu: Record<string, any>) => itemFromCategoryItems.menuAvailabilitiesIds.includes(menu.availability_id)) : [...menusWithCategory];
    const categoryAvailabilityInfos = CategoryHelper.getAvailabilityInfo(category, menusWithCategoryForItem, [itemFromCategoryItems], availabilities, config, isReadonly ? undefined : session.order_type as OrderType, session.pickup_at, t, locale, true);

    const getAvailabilityInfos = () => {
        if (itemFromCategoryItems.item_always_available) {
            return isReadonly ? [] : categoryAvailabilityInfos;
        }

        return itemAvailabilityInfos;
    }

    productAvailabilityInfos = getAvailabilityInfos();
    const infos: string[] = ItemAvailabilityHelper.getParsedAvailabilityInfos(productAvailabilityInfos);

    if (infos.length === 0) return <></>;

    return drawAvailabilityInfo(infos);
}

export default MenuCategoryProductAvailabilityInfo;